export function getUrlFilename(url: string): string | null {
  return ((url.split('/').pop() as string).split('#').shift() as string).split('?').shift() || null
}
